import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { PRIMENG_MODULES } from '../../shared/primeng-imports';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { MenuItem } from 'primeng/api';
import { filter, Observable, Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../shared/services/auth.service';
import { Router } from '@angular/router';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { DataService } from '../../shared/services/data.service';
import { ExportBarcodesComponent } from "../export-barcodes/export-barcodes.component";
import { environment } from '../../../environments/environment';
import { ParcelSummaryComponent } from '../parcel-summary/parcel-summary.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [...PRIMENG_MODULES, ExportBarcodesComponent,ParcelSummaryComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  isLoggedIn: boolean = false;

  isAdminGroup = false;
  profileItems: MenuItem[] = [];
  visible: boolean = false
  isCustomsGroup: boolean = false;
  showtabs = true;
  isSuperUser: boolean = false;
  loggedInUser: string = '';
  showInactiveDialog: boolean = false;
  isActiveUserDialogMsg: string = 'Error';

  userStatus$!: Observable<{ isActive: boolean; message: string }>;
  private readonly _destroying$ = new Subject<void>();
  constructor(
    private authService: MsalService,
    public userAuthService: AuthService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private dataService: DataService
  ) { }
  async ngOnInit() {
    this.checkAccount()
  }

  checkAccount() {
    const accounts = this.authService.instance.getAllAccounts();
    this.isLoggedIn = accounts.length > 0;
    if (this.isLoggedIn) {
      const claims = accounts[0].idTokenClaims as any;
      const groups = claims?.groups || []
      const name = claims.name;
      this.loadProfile(groups, name);
    }
  }

  logout() {
    this.authService.logoutRedirect();
  }
  showDialog() {
    this.visible = true;
  }
  routeToPage(route: string) {
    this.dataService.updateShowMaintabs(false);
    this.router.navigate([route])
  }
  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
  loadProfile(groups: any, name: any) {

    const userGroup: any[] = groups;

    const matchForNormalUser = userGroup.filter(grp => grp.includes('DIA-NormalUser-'));
    const matchForCustomUser = userGroup.filter(grp => grp.includes('DIA-CustomsUser-'));
    const matchForAdmin = userGroup.filter(grp => grp.includes('DIA-CustomsAdminUser-'));
    this.isSuperUser = (userGroup.filter(grp => grp.includes('DIA-SuperUser-'))).length > 0 ? true : false;
    this.isAdminGroup = matchForAdmin.length > 0 ? true : false;
    this.isCustomsGroup = matchForCustomUser.length > 0 ? true : false;
    this.profileItems = [
      {
        label: name.split(',')[0],
        disabled: true,
        icon: 'pi pi-user'
      },
      ...(this.isAdminGroup) ? [{
        label: 'Export',
        icon: 'pi pi-file-export',
        command: () => this.showDialog()
      }] : [],
      ...(this.isSuperUser) ? [{
        label: 'User Management',
        icon: 'pi pi-users',
        command: () => this.routeToPage('/UserManagement')
      }] : [],
      {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        command: () => this.logout()
      }
    ];

  }

  eventClose() {
    this.visible = false;
  }
}
